
import { defineComponent } from 'vue';
import FormPopup from "../main/FormPopup.vue";

export default defineComponent({
    name: "MailForm",

    components:{
        FormPopup
    },

    data(){
        return{

                /* To Change */

            // Messages
            msgSuccess: "Form submitted successfully. I will contact you as soon as possible!",
            msgFailed: "Something went terribly wrong :( Please try again!",

            msgLongResponse: "Your email is on its way, but it may take a bit longer!",
            msgReallyLongResponse: "It seems like there are some technical difficulties :/<br>Feel free to contact me directly at wbocho378@gmail.com.",

            msgAttempts: "Too many attempts! Try again in a few minutes.",
            msgEmptyFields: "Didn't you forget something? :)",
            msgInvalidMail: "Please provide a valid email address!",

            // Popup Time (in seconds)
            popupShowTime: 6, // The time the popup is shown
            popupScrollTime: 0.5, // The time after the popup is hidden after scroling

            // Popup
            popupMsg: "",
            popupVisible: false,
            popupTimeout: null as null | number,

            // Mail
            maxAttemptNumber: 8,
            tumbleweed: "address",
            apiResponseDelay: 3, // in seconds
            apiLongResponseDelay: 10, // in seconds
            
                /* In-code */

            // Mail
            mailNumber: 0,
            tooManyAttempts: false,
            emailRegex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,

            // Form
            form: null as null | HTMLFormElement,
            formInpVal: null as null | HTMLInputElement[],
            inputValidCheck: false,

            // Key
            mailProvider: "https://formspree.io/f/",
            key: "eHl5cXZlZ3Y="

        } 
    },

    mounted(){

        // Elements
        this.form = this.$refs.contactForm as HTMLFormElement;
        this.formInpVal = Array.from(this.form.querySelectorAll(".input-valid")) as HTMLInputElement[];

        // Set the popup message in case something is wrong
 //       (this.$refs.infoMsg as HTMLElement).innerHTML = this.msgFailed;

        // Close the popup faster when scrolling
        document.addEventListener("scroll", () => {
            
            if (this.popupTimeout){
                clearTimeout(this.popupTimeout);
            }

            this.popupTimeout = setTimeout(() => {
                this.popupVisible = false;
            }, this.popupScrollTime * 1000);
       
        });

        // Remove the invalid input class on user input
        this.formInpVal.forEach(input => {
            input.addEventListener("input", () => {

                if (this.formInpVal && this.inputValidCheck){
                    this.formInpVal.forEach(input => {
                        
                        if (input.value.length > 0){
                            input.classList.remove("invalid-input");
                        } else {
                            input.classList.add("invalid-input");
                        }

                    });
                }

            });
        });

    },

    methods:{

            /* Basics */

        decodeKey(){
            return atob(this.key);
        },

            /* Popup */

        closePopup(){
            this.popupVisible = false;
        },

        showPopup(){

            this.popupVisible = true;

            if (this.popupTimeout){
                clearTimeout(this.popupTimeout);
            }

            this.popupTimeout = setTimeout(() => {
                this.popupVisible = false;
            }, this.popupShowTime * 1000);

        },

        formTxt(message: string){

            const formInfoTxt = (this.$refs.infoMsg as HTMLElement);
            this.popupMsg = message;
            this.showPopup();

        },

            /* Validation */

        removeInvalidClass(){

            if (this.formInpVal){
                this.formInpVal.forEach(input => {
                    input.classList.remove("invalid-input");
                });
            }

        },

        checkMail(){

            const emailInput = this.$refs.email as HTMLInputElement;
            let isValidated = true;

            if (!this.emailRegex.test(emailInput.value)){
                this.formTxt(this.msgInvalidMail);
                emailInput.classList.add("invalid-input");
                isValidated = false;
            }

            return isValidated;
            
        },

        checkValidation(){

            let isValidated = true;
            let emptyFields = false;

            this.removeInvalidClass();
            isValidated = this.checkMail();

            if (this.formInpVal){
                this.formInpVal.forEach(input => {
                    if (input.value.trim() === ""){
                        input.classList.add("invalid-input");
                        isValidated = false;
                        emptyFields = true;
                    }
                });
            }

            if (emptyFields){
                this.formTxt(this.msgEmptyFields);
            }

            return isValidated;

        },

            /* Bot Prevention */

        checkAttemptTimer(){

            const attemptCooldown = localStorage.getItem("attemptCooldown");

            if (attemptCooldown){
                const attemptCooldownVal = parseInt(attemptCooldown, 10);

                if (Date.now() < attemptCooldownVal){
                    this.tooManyAttempts = true;
                } else {
                    this.mailNumber = 0;
                    this.tooManyAttempts = false;
                    localStorage.removeItem("attemptCooldown");
                }
            }

        },

        setAttemptTimer(){

            this.tooManyAttempts = true;
            const time = 1000 * 60 * 1; // 1 min
            
            const attemptCooldown = Date.now() + time;
            localStorage.setItem("attemptCooldown", attemptCooldown.toString());

        },

        preventBot(){

            // Check if the tumbleweed input was filled out by a bot
            if ((this.$refs.tumbleweed as HTMLInputElement).value === ""){
                return false;
            } else {
                this.formTxt(this.msgSuccess);
          
                this.setAttemptTimer();
                return true;
            }

        },

        preventSpam(){

            // Too many submit attempts
            if (this.mailNumber >= this.maxAttemptNumber){
                this.setAttemptTimer();
            }

            if (this.mailNumber >= this.maxAttemptNumber || this.tooManyAttempts){
                this.formTxt(this.msgAttempts);
            }

        },

            /* Send Mail */

        async sendForm(e: Event){

                /* Basics */

            e.preventDefault();
            this.formTxt("");

            // Disable the button
            const sendBtn = this.$refs.sendFormBtn as HTMLElement;
            sendBtn.style.pointerEvents = "none";

            // Enable the check
            this.inputValidCheck = true;

            // Increase the attempt number
            this.mailNumber++;
            
            // Form Data
            const data = new FormData(this.form as HTMLFormElement);
            
                /* Checks */

            // Validation
            const isValidated = this.checkValidation();

            // Spam Prevention
            this.checkAttemptTimer();
            this.preventSpam();

            // Validation Check
            if (!isValidated || this.tooManyAttempts || this.preventBot()){
                sendBtn.style.pointerEvents = "all";
                return;
            }

                /* Form */

            // Delete the tumbleweed input
            data.delete(this.tumbleweed);

            // Delayed API response initiation
            const delayTimer = setTimeout(() => {
                this.formTxt(this.msgLongResponse);
            }, this.apiResponseDelay * 1000);

            const delayTimerLong = setTimeout(() => {
                this.formTxt(this.msgReallyLongResponse);
            }, this.apiLongResponseDelay * 1000);

            // Send the server request
            fetch(this.mailProvider + this.decodeKey(), {

                method: this.form!.method,
                body: data,
                headers:{
                    'Accept': 'application/json'
                }

            })

            // Receive server response
            .then(response => {

                // Clear the timer if the API responded in time
                clearTimeout(delayTimer);
                clearTimeout(delayTimerLong);

                // Handle the API response
                if (response.ok){
                    
                    this.formTxt(this.msgSuccess);
                    this.inputValidCheck = false;
                    this.form!.reset();

                } else {

                    response.json().then(data => {

                        if ('errors' in data){
                            console.log("Form Error: " + 
                                data["errors"].map(
                                        (error: { message: string }) => error["message"]
                                ).join(", ")
                            );
                        }
                        
                    });

                    this.formTxt(this.msgFailed);

                }

                // Enable the button
                sendBtn.style.pointerEvents = "all";

            })

            // Errors
            .catch(error => {

                this.formTxt(this.msgFailed);
                sendBtn.style.pointerEvents = "all";
                console.log("Form Error: " + error);

            });

        }

    }

});
